import { PHONE, locationSchema } from "../structured-data-core";

export function getSanFranciscoStructuredData() {
  const url = "https://restorehair.com/locations/california/san-francisco/";
  const description =
    "Find out about your hair transplant options in San Francisco with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("San Francisco", "100 Pine Street, Suite 1250", "San Francisco", "CA", PHONE, url, description),
  ];
}
